export default "__VITE_ASSET__DfuqmE1K__"